/* @flow */

import React from 'react';
import { useSelector } from 'react-redux';
import { Route, Switch, useRouteMatch } from 'react-router-dom';

import Error404Page from 'components/errors/error404';
import RestrictedRoute from 'components/route/restrictedRoute';

import SupplierDashboardPage from './dashboard';
import SupplierInvoiceDetailsPage from './invoiceDetails';
import SupplierOffersPage from './offers';
import { PROTECTED_SUPPLIER_DASHBOARD } from 'constants/pageRoutes';

export default function SupplierPage() {
  const canExecute = useSelector(state => state.auth.user.activeCompany.roleSupplier.canExecute);
  const match = useRouteMatch();

  return (
    <Switch>
      <Route exact path={`${match.url}/`} component={SupplierDashboardPage} />
      <Route path={`${match.url}/offer`} component={SupplierOffersPage} redirectUrl={PROTECTED_SUPPLIER_DASHBOARD} />
      <Route path={`${match.url}/invoice/:id`} component={SupplierInvoiceDetailsPage} />
      <Route component={Error404Page} />
    </Switch>
  );
}
